/**
 * Copies text to the clipboard. The async Clipboard API is refused in
 * insecure contexts, embedded webviews and when the page lacks focus or
 * permission, so the legacy `execCommand('copy')` path is tried next.
 * Resolves `false` instead of throwing when neither works, so callers can
 * show the text for a manual copy rather than reporting an error.
 */
export const copyToClipboard = async (text: string): Promise<boolean> => {
	try {
		if (navigator?.clipboard?.writeText) {
			await navigator.clipboard.writeText(text);
			return true;
		}
	} catch (e) {
		// fall through to the legacy path
	}

	try {
		const textarea = document.createElement('textarea');
		textarea.value = text;
		textarea.setAttribute('readonly', '');
		textarea.style.position = 'fixed';
		textarea.style.opacity = '0';
		document.body.appendChild(textarea);
		textarea.select();
		const copied = document.execCommand('copy');
		document.body.removeChild(textarea);
		return copied;
	} catch (e) {
		return false;
	}
};
